var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('WriterProfile',{attrs:{"user-id":("" + (this.$route.params.id)),"allowed-keys":_vm.allowedKeys}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }